// extracted by mini-css-extract-plugin
module.exports = {"icon":"invite-as-friend_icon__4pp9b","container":"invite-as-friend_container__aq2ep"};